module.exports = __webpack_public_path__ + "img/reddit.7f690526.svg";